var api = require("!../../../../../../common/temp/node_modules/.pnpm/style-loader@1.3.0_webpack@5.68.0/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../../../../common/temp/node_modules/.pnpm/css-loader@3.2.1_webpack@5.68.0/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[4].use[1]!./mentions.module.css");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};